import { Box, Theme, Typography } from '@mui/material';

import { useStore } from '@store/GlobalStore';
import { FallbackProps } from 'react-error-boundary';
import { shallow } from 'zustand/shallow';

const fallbackSidebarContainerStyle = (theme: Theme) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'fixed',
  left: '-284px',
  height: 'calc(100vh - 80px)',
  animation: theme.animations.slide,
  width: '284px',
  marginLeft: '52px',
  background: 'background.paper',
  borderRight: theme.borders.main,
  boxShadow: 'boxShadow[3]',
  zIndex: 1,
});

export const FallbackSidebar = ({ error }: FallbackProps) => {
  const { isInternalUser } = useStore((state) => state.userAuth, shallow);
  console.error(error);
  return (
    <Box sx={fallbackSidebarContainerStyle}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Typography variant='body' sx={{ mb: '12px', fontWeight: 'bold' }}>
          Something went wrong.
        </Typography>
        <Typography variant='caption' sx={{ mb: '5px' }}>
          There has been an issue loading the sidebar.
        </Typography>
        {!isInternalUser && (
          <>
            <Typography variant='caption' sx={{ mb: '5px' }}>
              Please try again or contact LIO support at
            </Typography>
            <Typography variant='caption' sx={{ mb: '5px' }}>
              <a href='mailto:service@lioinsurance.com'>service@lioinsurance.com</a>, or call
            </Typography>
            <Typography variant='caption' sx={{ mb: '5px' }}>
              877-546-7155 M-F between 8:30am -
            </Typography>
            <Typography variant='caption' sx={{ mb: '5px' }}>
              8:00pm ET.
            </Typography>
          </>
        )}
      </Box>
    </Box>
  );
};
